import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';

import { CookieService } from '../cookie.service';
import { SessionService } from '../session.service';
import { getAuthHeaders, getUserAuth } from 'src/app/core/http/user-auth';
import {
  AUTH_TOKEN_HEADER_NAME,
  USER_EMAIL_HEADER_NAME,
  SESSION_ID_HEADER_NAME,
} from '../../shared/constants/auth.constants';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private cookieService: CookieService,
    private sessionService: SessionService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const httpMethod = req.method;
    const userAuth = getUserAuth();
    let headers = req.headers.set(SESSION_ID_HEADER_NAME, this.sessionService.getSessionId());

    if (
      (httpMethod === 'PUT' || httpMethod === 'POST' || httpMethod === 'DELETE') &&
      userAuth?.token
    ) {
      // for not secured endpoints like login, /api/v1/auth/verify/**", "/api/v1/auth/password-reset/**", "/api/v1/auth/passwords/**",
      // cookie will be null so we need to add some placeholder value to header (it cannot be null)
      const authHeaders = getAuthHeaders();
      headers = headers
        .set(AUTH_TOKEN_HEADER_NAME, authHeaders.token)
        .set(USER_EMAIL_HEADER_NAME, authHeaders.email);
    }

    return next.handle(req.clone({ headers }));
  }
}
